<div class="wrapper">
	<div class="text-container" role="region" aria-label="Text content">
		<ion-row role="region" aria-label="Content section">
			<ion-col>
				<h3>{{ 'reset_password.header' | translate }}</h3>
				<p class="email-msg">{{ 'reset_password.msg1' | translate }}</p>
				<!-- <p class="email-msg">{{ 'reset_password.msg2' | translate }}</p> -->
			</ion-col>
			<ion-icon (click)="dismiss()" size="large" name="close" role="img" aria-label="Close icon"></ion-icon>
		</ion-row>
		<ion-row role="region" aria-label="Content section">
			<ion-col>
				<ion-item [class.input-error]="!isValidEmail" class="input" lines="none">
					<ion-input
						(ngModelChange)="resetValidation()"
						[(ngModel)]="email"
						name="email"
						placeholder="{{ 'sign_in.email' | translate }}"
						type="email"
					></ion-input>
				</ion-item>
			</ion-col>
		</ion-row>
	</div>
	<ion-row role="region" aria-label="Content section">
		<ion-col class="button-block">
			<ion-button class="button" (click)="dismiss()">
				{{ 'reset_password.cancel_btn' | translate }}
			</ion-button>
			<ion-button class="button" (click)="sendEmail()">
				{{ 'reset_password.ok_btn' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
